<template>
    <!--用餐评价-->
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="用餐评价" lefttext="返回" @leftclick="togo('/application')"></my-top>
            <pull-refresh v-model="refreshing" @refresh="onRefresh">
                <list class="cont-box"
                      v-model="loading"
                      :finished="finished"
                      finished-text="没有更多了"
                      @load="getlistdata">
                    <div class="item-box">
                        <div v-for="(item, n) in list" :key="n">
                            <cell class="simpleList" @click="togo('/application/canteen/evaluate/form', {disabled:true, listId:item.id})">
                                <template #title>
                                    <div style="overflow: hidden">
                                        <div style="max-width: calc(100% - 80px); float: left">
                                            <div class="van-ellipsis">用餐评价</div>
                                        </div>
                                    </div>
                                </template>
                                <template #label>
                                    <div class="van-ellipsis">
                                        <div class="van-ellipsis">{{item.createTime || '无'}}</div>
                                    </div>
                                </template>
                                <template #right-icon>
                                    {{item.score || '无'}}
                                </template>
                            </cell>
                        </div>
                    </div>
                </list>
            </pull-refresh>
        </div>
        <div class="btnSub">
            <van-button block type="info" :loading="loadingSub" loading-text="校验中..." @click="handleSubmit">用餐评价</van-button>
        </div>

    </div>
</template>

<script>
    import {Cell, Dialog, List, PullRefresh} from 'vant';
    import application from '@api/application';
    // import loading from "../../../utils/loading";
    export default {
        name:'canteenEvaluate',
        components: {Cell,List,PullRefresh,Dialog},
        data() {
            return {
                list: [],
                loading: false,
                loadingSub: false,
                finished: false,
                refreshing: false,
                query: {
                    pageNo: 1,
                    pageSize: 5,
                    needCount: true,
                    query: {
                    }
                },
            }
        },
        methods: {
            handleSubmit(){
                /**
                 * 获取采购供应商数据
                 **/
                let supplier;
                this.loadingSub = true;
                let form={
                    id:JSON.parse(localStorage.getItem("vuex")).user.company.id,
                    supId: '0' //1：食堂采购；0：食堂考核、用餐评价、用餐人数
                }
                application.getOfficeCanteenByOrgId(form).then(res =>{
                    if(res.code == 200){
                        supplier = res.data
                        if(supplier && supplier.length>1){
                            this.$router.push({
                                path: '/application/canteen/evaluate/form',
                            })
                        }else {
                            Dialog.alert({
                                message: '您所属单位下无食堂信息，不能进行食堂评价',
                                closeOnClickOverlay: true
                            }).then(()=>{
                            })
                        }
                    }
                    this.loadingSub = false;
                }).catch(()=>{
                    this.loadingSub = false;
                })
            },
            getlistdata(type='add') {
                if(this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(type=='new') {
                    this.list = [];
                    this.query.pageNo=1;
                    this.loading = true;
                    this.finished = false;
                }
                application.queryOfficeCanteenAppraiseList(this.query).then(res=> {
                    if(res.code==0) {
                        this.list = this.list.concat(res.data);
                        this.query.pageNo++;
                        this.loading = false;
                        // if(res.currentPage>=res.totalPage) {
                        //     this.finished = true;
                        // }
                        this.finished = true;
                    }else {
                        this.loading = false;
                        this.finished = true;
                    }
                }).catch(() => {
                    this.loading = false;
                    this.finished = true;
                })
            },
            searchLoad() {
                this.getlistdata('new');
            },
            onRefresh() {
                this.getlistdata('new');
                this.finished = false;
                this.loading = true;
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .down{
        transition: all 1ms;
    }
    .up{
        transform:rotate(-180deg);
        transition: all 1ms;
    }

    .view{
        background-color: #FFFFFF;
    }
    .content {
        padding-bottom:50px;
        .screenbox {
            width:100%;
            position:fixed;
            left:0;
            z-index:2;
            .sarch {
                ::v-deep .van-search{
                    .van-search__content {
                        border-radius:20px;
                    }
                }
            }
            .sarchtabs {
                ::v-deep .van-tabs__line{
                    background-color:#018fe0;
                    bottom: 18px;
                }
            }
        }
        .cont-box {
            /*padding: 1rem;*/
            .item-box {
                background-color: #FFFFFF;
                overflow: hidden;
                .van-cell__title{
                    overflow: hidden;
                }
                .titBtn{
                    display: inline-block;
                    font-size: 12px;
                    padding: 2px 8px;
                    margin-left: 10px;
                    border-radius:4px;
                }
                .titBtn.err{
                    color: #F5222D;
                    border:1px solid #FFA39E;
                    background-color: #FEF0EF;
                }
                .titBtn.default{
                    color: #000000;
                    border:1px solid #D9D9D9;
                    background-color: #F5F5F5;
                }
            }
            .simpleList{
                border-bottom: 1px solid #dddddd;
                display:flex;
                /*justify-content: center;*/
                align-items: center;
                .listItem{
                    font-size: 14px;
                    display: flex;
                    display: -webkit-box;
                    display: -webkit-flex;
                    box-sizing: border-box;
                    width: 100%;
                    line-height: 24px;
                    white-space: normal;
                    text-align: left;
                    .listTitle, .listVal{
                        flex: 1;
                        -webkit-box-flex:1;
                        -webkit-flex:1;
                    }
                    .listVal{
                        text-align: right;
                    }
                }
                .listCtn{
                    color: #999999;
                    font-size: 12px;
                    .listVal{
                        font-size: 12px;
                    }
                }
                .listBtn{
                    .listTitle{
                        color: #018fe0;
                    }
                }
            }
        }
        .btn {
            >span:first-child {
                background-color:#70B603;
            }
            >span:last-child {
                background-color:#169BD5;
            }
        }
    }

</style>
